import React, { useEffect, useState } from 'react';
import { App } from 'App';
import { getFirstSegment } from 'utils/urls';
import { useQuery } from '@tanstack/react-query';
import { TenantsApi } from '../api';
import { LoadingPage } from './LoadingPage';
import { tenantInfoState } from '../atoms';
import { useSetRecoilState } from 'recoil';
import { ThemeProvider } from '@emotion/react';
import { Theme, useTheme } from '@mui/material';
import { createTenantTheme } from 'themes';

export const AppInitializer: React.FC = () => {
  const theme = useTheme();
  const [isLoaded, setIsLoaded] = useState(false);
  const [innerTheme, setInnerTheme] = useState<Theme>();
  const { data: tenantInfo, isFetched: tenantIsFetched } = useQuery(['tenantInfo'], TenantsApi.me);
  const { data: tenantTheme, isFetched: themeIsFetched } = useQuery(['tenantTheme'], TenantsApi.getTheme);
  const setTenantInfo = useSetRecoilState(tenantInfoState);

  const tenantId = tenantIsFetched && getFirstSegment() === tenantInfo?.identifier ? tenantInfo?.identifier : undefined;

  useEffect(() => {
    if (tenantIsFetched && tenantInfo) {
      setTenantInfo(tenantInfo);
      setIsLoaded(true);
    }
  }, [tenantIsFetched, tenantInfo, setTenantInfo]);

  useEffect(() => {
    if (themeIsFetched && tenantTheme) {
      setInnerTheme(createTenantTheme(theme, tenantTheme));
    }
  }, [theme, themeIsFetched, tenantTheme]);

  return (
    <>
      {
        isLoaded && innerTheme ?
          <ThemeProvider theme={innerTheme}>
            <App tenantId={tenantId} />
          </ThemeProvider>
          :
          <LoadingPage />
      }
    </>
  );
};